import { ObserveVisibility } from 'vue-observe-visibility';
import { nextFrame } from '../../utils/dom.js';
import { scaleToFit } from '../../utils/scale-to-fit.js';

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }
  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}
function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _empty() {}
function _invokeIgnored(body) {
  var result = body();
  if (result && result.then) {
    return result.then(_empty);
  }
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}
var script = {
  directives: {
    ObserveVisibility
  },
  props: {
    layout: {
      type: Object,
      required: true
    },
    offset: {
      type: Number,
      default: 32
    }
  },
  data() {
    return {
      isHidden: true
    };
  },
  computed: {
    isMobileLayout() {
      return this.layout.supportedPlatforms && this.layout.supportedPlatforms.mobile;
    },
    isWebLayout() {
      return this.layout.supportedPlatforms && this.layout.supportedPlatforms.web;
    }
  },
  methods: {
    handleVisibilityChange: _async(function (isVisible) {
      const _this = this;
      return _invokeIgnored(function () {
        if (isVisible) {
          return _call(nextFrame, function () {
            if (window.pendo) {
              window.pendo.flexElement(_this.$el);
            }
            return _await(_this.scaleLayoutPreview(), function () {
              return _call(nextFrame, function () {
                _this.isHidden = false;
              });
            });
          });
        } else {
          _this.isHidden = true;
        }
      });
    }),
    scaleLayoutPreview: _async(function () {
      const _this2 = this;
      const scaleConfig = {
        element: _this2.$el,
        offset: _this2.offset
      };
      if (_this2.layout.type && _this2.layout.type.includes('mobilePopUpBlank')) {
        scaleConfig.offset = 64;
      }
      if (_this2.isMobileLayout) {
        scaleConfig.aspectRatio = 9 / 16;
        scaleConfig.maxScale = 1;
      }
      return _awaitIgnored(scaleToFit(scaleConfig));
    })
  }
};

export { script as default };
//# sourceMappingURL=pendo-layout-preview.vue2.js.map
